import {
  CITY_LIST_REQUEST,
  CITY_LIST_REQUEST_ERROR,
  CITY_LIST_REQUEST_SUCCESS,
  HOUSE_TYPE_LIST_REQUEST,
  HOUSE_TYPE_LIST_REQUEST_ERROR,
  HOUSE_TYPE_LIST_REQUEST_SUCCESS,
  DEGREE_LIST_REQUEST,
  DEGREE_LIST_REQUEST_ERROR,
  DEGREE_LIST_REQUEST_SUCCESS,
  JOB_TYPE_LIST_REQUEST,
  JOB_TYPE_LIST_REQUEST_ERROR,
  JOB_TYPE_LIST_REQUEST_SUCCESS,
  JOB_POSITION_TYPE_LIST_REQUEST,
  JOB_POSITION_TYPE_LIST_REQUEST_ERROR,
  JOB_POSITION_TYPE_LIST_REQUEST_SUCCESS,
  BANK_LIST_REQUEST,
  BANK_LIST_REQUEST_ERROR,
  BANK_LIST_REQUEST_SUCCESS,
  RELATIONSHIP_TYPE_LIST_REQUEST,
  RELATIONSHIP_TYPE_LIST_REQUEST_ERROR,
  RELATIONSHIP_TYPE_LIST_REQUEST_SUCCESS,
} from '@/store/actions/other';
import { handleRequestError } from '@/utils/error';

import Repository, { OTHERS } from '@/repositories/RepositoryFactory';

const OthersRepository = Repository.get(OTHERS);

const state = {
  cityList: [],
  cityStatus: '',
  houseTypeList: [],
  houseTypeStatus: '',
  degreeList: [],
  degreeStatus: '',
  jobTypeList: [],
  jobTypeStatus: '',
  jobPositionTypeList: [],
  jobPositionTypeStatus: '',
  bankList: [],
  bankStatus: '',
  relationshipTypeList: [],
  relationshipTypeStatus: '',
};

const getters = {
  cityList: state => state.cityList,
  cityStatus: state => state.cityStatus,
  houseTypeList: state => state.houseTypeList,
  houseTypeStatus: state => state.houseTypeStatus,
  degreeList: state => state.degreeList,
  degreeStatus: state => state.degreeStatus,
  jobTypeList: state => state.jobTypeList,
  jobTypeStatus: state => state.jobTypeStatus,
  jobPositionTypeList: state => state.jobPositionTypeList,
  jobPositionTypeStatus: state => state.jobPositionTypeStatus,
  bankList: state => state.bankList,
  bankStatus: state => state.bankStatus,
  relationshipTypeList: state => state.relationshipTypeList,
  relationshipTypeStatus: state => state.relationshipTypeStatus,
};

const actions = {
  [CITY_LIST_REQUEST]: async ({ commit }) => {
    commit(CITY_LIST_REQUEST);
    try {
      const response = await OthersRepository.getCityList();
      commit(CITY_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(CITY_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [HOUSE_TYPE_LIST_REQUEST]: async ({ commit }) => {
    commit(HOUSE_TYPE_LIST_REQUEST);
    try {
      const response = await OthersRepository.getHouseTypeList();
      commit(HOUSE_TYPE_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(HOUSE_TYPE_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [DEGREE_LIST_REQUEST]: async ({ commit }) => {
    commit(DEGREE_LIST_REQUEST);
    try {
      const response = await OthersRepository.getDegreeList();
      commit(DEGREE_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(DEGREE_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [JOB_TYPE_LIST_REQUEST]: async ({ commit }) => {
    commit(JOB_TYPE_LIST_REQUEST);
    try {
      const response = await OthersRepository.getJobTypeList();
      commit(JOB_TYPE_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(JOB_TYPE_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [JOB_POSITION_TYPE_LIST_REQUEST]: async ({ commit }) => {
    commit(JOB_POSITION_TYPE_LIST_REQUEST);
    try {
      const response = await OthersRepository.getJobPositionTypeList();
      commit(JOB_POSITION_TYPE_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(JOB_POSITION_TYPE_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [BANK_LIST_REQUEST]: async ({ commit }) => {
    commit(BANK_LIST_REQUEST);
    try {
      const response = await OthersRepository.getBankList();
      commit(BANK_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(BANK_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [RELATIONSHIP_TYPE_LIST_REQUEST]: async ({ commit }) => {
    commit(RELATIONSHIP_TYPE_LIST_REQUEST);
    try {
      const response = await OthersRepository.getRelationshipTypeList();
      commit(RELATIONSHIP_TYPE_LIST_REQUEST_SUCCESS, response.data.data);
    } catch (error) {
      commit(RELATIONSHIP_TYPE_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
};

const mutations = {
  [CITY_LIST_REQUEST]: state => {
    state.cityStatus = 'loading';
  },
  [CITY_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.cityStatus = 'success';
    state.cityList = payload;
  },
  [CITY_LIST_REQUEST_ERROR]: state => {
    state.cityStatus = 'error';
  },
  [HOUSE_TYPE_LIST_REQUEST]: state => {
    state.houseTypeStatus = 'loading';
  },
  [HOUSE_TYPE_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.houseTypeStatus = 'success';
    state.houseTypeList = payload;
  },
  [HOUSE_TYPE_LIST_REQUEST_ERROR]: state => {
    state.houseTypeStatus = 'error';
  },
  [DEGREE_LIST_REQUEST]: state => {
    state.degreeStatus = 'loading';
  },
  [DEGREE_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.degreeStatus = 'success';
    state.degreeList = payload;
  },
  [DEGREE_LIST_REQUEST_ERROR]: state => {
    state.degreeStatus = 'error';
  },
  [JOB_TYPE_LIST_REQUEST]: state => {
    state.jobTypeStatus = 'loading';
  },
  [JOB_TYPE_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.jobTypeStatus = 'success';
    state.jobTypeList = payload;
  },
  [JOB_TYPE_LIST_REQUEST_ERROR]: state => {
    state.jobTypeStatus = 'error';
  },
  [JOB_POSITION_TYPE_LIST_REQUEST]: state => {
    state.jobPositionTypeStatus = 'loading';
  },
  [JOB_POSITION_TYPE_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.jobPositionTypeStatus = 'success';
    state.jobPositionTypeList = payload;
  },
  [JOB_POSITION_TYPE_LIST_REQUEST_ERROR]: state => {
    state.jobPositionTypeStatus = 'error';
  },
  [BANK_LIST_REQUEST]: state => {
    state.bankStatus = 'loading';
  },
  [BANK_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.bankStatus = 'success';
    state.bankList = payload;
  },
  [BANK_LIST_REQUEST_ERROR]: state => {
    state.bankStatus = 'error';
  },
  [RELATIONSHIP_TYPE_LIST_REQUEST]: state => {
    state.relationshipTypeStatus = 'loading';
  },
  [RELATIONSHIP_TYPE_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.relationshipTypeStatus = 'success';
    state.relationshipTypeList = payload;
  },
  [RELATIONSHIP_TYPE_LIST_REQUEST_ERROR]: state => {
    state.relationshipTypeStatus = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
